import { moduleProviderFactory } from 'core/providers';
import { ReturnAddressList } from 'modules/return-address/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.return-address',
				pattern: '/return-address',
				isPrivate: true,
				authorization: ['shippingCarrierSection.full'],
				children: [
					{
						name: 'master.app.main.return-address.list',
						pattern: '',
						component: ReturnAddressList,
					},
				],
			},
		],
	});
})();
